<div class="accordion-header">
  <ng-container
    [ngTemplateOutlet]="
      accordionHeaderTemplate() || defaultAccordionHeaderTemplate
    "
    [ngTemplateOutletContext]="{ $implicit: title(), title: title() }"
  />
</div>

<ng-template #defaultAccordionHeaderTemplate>
  <h3 class="accordion-header__title">{{ title() }}</h3>
</ng-template>
